export var VELT_SDK_VERSION = '4.5.0-beta.33';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.0-beta.33': 'sha384-ZP1/rBivB52YB3A6xq5FOrG55O++ldQEhyf1TiM60VW34/PmM1egiR6XMAXiWgXc',
};
